"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const dynamic_1 = __importDefault(require("next/dynamic"));
const next13_utils_common_to_kebap_case_1 = __importDefault(require("@gerenciatd/next13.utils.common.to-kebap-case"));
// modulito
const ERROR_COLOR = '\x1b[31m%s\x1b[0m'; // red
const Glyph = (props) => {
    const { id, kind } = props;
    try {
        const Icono = (0, dynamic_1.default)(() => Promise.resolve().then(() => __importStar(require(`@gerenciatd/next13.glyph.${(0, next13_utils_common_to_kebap_case_1.default)(id)}-${kind}/dist/index.js`))).catch(() => {
            console.log(ERROR_COLOR, `Error al importar el icono ${id}, compruebe que existe`);
            return () => react_1.default.createElement(react_1.default.Fragment, null);
        }));
        if (!Icono) {
            return react_1.default.createElement(react_1.default.Fragment, null);
        }
        return react_1.default.createElement(Icono, Object.assign({}, props));
    }
    catch (error) {
        console.log(ERROR_COLOR, `Error al renderizar el icono ${id}, compruebe que esté instalado`);
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
};
Glyph.propTypes = {
    kind: prop_types_1.default.string,
};
Glyph.defaultProps = {
    kind: "m",
};
exports.default = Glyph;
//# sourceMappingURL=index.js.map